import React from 'react'
import { Container, Row, Col } from 'react-bootstrap';
import styles from './home.module.scss';


const HomeDesc = () => {
    return (<>
        <Container className={styles.mainContainer}>
            <h2 className="mb-5" className={'centerText'}>Bringing excellence to healthcare decision making, quality improvement, and research</h2>
            <Row className="mt-4">
                <Col sm={12} md={8}>
                    <p className="body">Quality Indicators (QIs) are standardized, evidence-based measures of health care quality that can be used with readily available hospital inpatient administrative data to measure and track clinical performance and outcomes.</p>
                </Col>
                <Col sm={12} md={4}>
                    <div className={styles.checkList}><i className="fa fa-check"></i><p className={'bold'}>Highlight potential quality improvement areas</p></div>
                    <div className={styles.checkList}><i className="fa fa-check"></i><p className={'bold'}>Track changes over time</p></div>
                    <div className={styles.checkList}><i className="fa fa-check"></i><p className={'bold'}>Identify areas for further study</p></div>
                </Col>
            </Row>
        </Container>
    </>)
}

export default HomeDesc;